import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainLayoute from './layoutes/MainLayoute';
import Homepage from './Pages/Home/Common/Homepage';
import About from './Pages/AboutUs/About';
import Contact from './Pages/ContactUs/Contact';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <MainLayoute>
              <Homepage />
            </MainLayoute>
          }
        />
        <Route
          path="/about-us"
          element={
            <MainLayoute>
              <About />
            </MainLayoute>
          }
        />
        <Route
          path="/contact-us"
          element={
            <MainLayoute>
              <Contact />
            </MainLayoute>
          }
        />
      </Routes>
    </Router>
  )
}

export default App;
